import React from 'react'
import PropTypes from 'prop-types'
import { Tab, Row, PanelGroup, Panel } from 'react-bootstrap'
import styled, { withTheme } from 'styled-components'
import scrollToElement from 'scroll-to-element'
import { ContentFilter, QuickFeedback } from '..'
import { Wrapper } from './ExpressContent'
import { MoreHelpFooterContainer } from '../../containers'

import messages from './messages'
import { OptionsHOC } from '../../hocs'

const ContentNotFound = styled.h1`
  font-size: 3.2em !important;
`

const FilteredContent = ({ createUserEvent, language, filtered }) => {
  const onPanelEntered = faq => {
    scrollToActive(faq.pk)
  }

  const scrollToActive = id => {
    setTimeout(function() {
      window.requestAnimationFrame(function() {
        scrollToElement(`[data-id="${id}"]`, {
          offset: 0,
          duration: 500
        })
      })
    }, 0)
  }

  const translated = messages[language]

  return (
    <div style={{ paddingTop: '15px' }} className="animated fadeIn">
      <Wrapper id="landing-page">
        <Tab.Container id="primary-container">
          <div>
            <Tab.Content animation mountOnEnter unmountOnExit>
              <Row>
                <Tab.Content animation mountOnEnter unmountOnExit>
                  <PanelGroup
                    id="tabcontent-panel"
                    accordion
                    bsClass="panel-group faq-list"
                  >
                    {filtered.map((faq, index) => {
                      return (
                        <Panel
                          eventKey={`faq_${faq.pk}`}
                          key={`subfaq_${index}`}
                          data-id={faq.pk}
                        >
                          <Panel.Heading>
                            <Panel.Title>
                              <Panel.Toggle componentClass="a">
                                {faq.name}
                              </Panel.Toggle>
                            </Panel.Title>
                          </Panel.Heading>
                          <Panel.Collapse onEntered={() => onPanelEntered(faq)}>
                            <Panel.Body>
                              <ContentFilter text={faq.val} />
                              <QuickFeedback
                                type="landing"
                                contentId={faq.pk}
                                createUserEvent={createUserEvent}
                              />
                            </Panel.Body>
                          </Panel.Collapse>
                        </Panel>
                      )
                    })}
                  </PanelGroup>
                </Tab.Content>
              </Row>
              {filtered.length === 0 && (
                <ContentNotFound>
                  {translated.empty.toUpperCase()}
                </ContentNotFound>
              )}
              <MoreHelpFooterContainer />
            </Tab.Content>
          </div>
        </Tab.Container>
      </Wrapper>
    </div>
  )
}

FilteredContent.propTypes = {
  createUserEvent: PropTypes.func.isRequired,
  language: PropTypes.string.isRequired,
  filtered: PropTypes.array.isRequired
}

export default withTheme(OptionsHOC(FilteredContent))



// WEBPACK FOOTER //
// ./src/components/ExpressHelp/FilteredContent.js